import BHHero from './BHHero';

export default BHHero;
